import BeEntrepreneurshipView from '../Views/BeEntrepreneurshipView.vue'
import StartProject from "../Pages/StartProject.vue"
import DeepCustomerEmpathy2 from "../Pages/DeepCustomerEmpathy2"
import DeepCustomerEmpathy3 from "../Pages/DeepCustomerEmpathy3"
import DeepCustomerEmpathy4 from "../Pages/DeepCustomerEmpathy4"
import DeepCustomerEmpathy5 from "../Pages/DeepCustomerEmpathy5"
import DeepCustomerEmpathy6 from "../Pages/DeepCustomerEmpathy6"
import DeepCustomerEmpathy7 from "../Pages/DeepCustomerEmpathy7"
import DeepCustomerEmpathy8 from "../Pages/DeepCustomerEmpathy8"
import DeepCustomerEmpathy9 from "../Pages/DeepCustomerEmpathy9"
import GoBroadToGoNarrow10 from "../Pages/GoBroadToGoNarrow10";
import GoBroadToGoNarrow11 from "../Pages/GoBroadToGoNarrow11";
import GoBroadToGoNarrow12 from "../Pages/GoBroadToGoNarrow12";
import GoBroadToGoNarrow13 from "../Pages/GoBroadToGoNarrow13";
import GoBroadToGoNarrow14 from "../Pages/GoBroadToGoNarrow14";
import GoBroadToGoNarrow15 from "../Pages/GoBroadToGoNarrow15";
import GoBroadToGoNarrow16 from "../Pages/GoBroadToGoNarrow16";
import RapidExperimentsWithCustomers17 from "../Pages/RapidExperimentsWithCustomers17";
import RapidExperimentsWithCustomers18 from "../Pages/RapidExperimentsWithCustomers18";
import RapidExperimentsWithCustomers19 from "../Pages/RapidExperimentsWithCustomers19";
import RapidExperimentsWithCustomers20 from "../Pages/RapidExperimentsWithCustomers20";
import RapidExperimentsWithCustomers21 from "../Pages/RapidExperimentsWithCustomers21";
import RapidExperimentsWithCustomers22 from "../Pages/RapidExperimentsWithCustomers22";
import RapidExperimentsWithCustomers23 from "../Pages/RapidExperimentsWithCustomers23";
import Finish24 from "../Pages/Finish24";
import Finish24startNewProject from "../Pages/Finish24startNewProject";
import DceBeforeYouContinue from "../Pages/DceBeforeYouContinue";

const routes = [
    {
        path: '/be_entrepreneurship',
        component: BeEntrepreneurshipView,
        children: [
            {
                path: '/be_start_project',
                name: 'be_start_project',
                component: StartProject,
                meta: {authRequired: true, showNavigation: false, showNavigationInfo: false, hideSideNavigation: true},
                props: {newProject: true}
            },
            {
                path: '/be_before_you_continue/:index',
                name: 'be_before_you_continue',
                component: DceBeforeYouContinue,
                meta: {authRequired: true, showNavigation: false, showNavigationInfo: false, hideSideNavigation: true}
            },
            {
                path: '/be_edit_project/:index',
                name: 'be_edit_project',
                component: StartProject,
                meta: {authRequired: true, showNavigation: false, showNavigationInfo: false, hideSideNavigation: true},
                props: {newProject: false}
            },
            {
                path: '/be_deep_customer_empathy_2/:index',
                name: 'be_deep_customer_empathy_2',
                component: DeepCustomerEmpathy2,
                meta: {authRequired: true, showNavigation: false, showNavigationInfo: false, pageNumber: "2 of 24"}
            },
            {
                path: '/be_deep_customer_empathy_3/:index',
                name: 'be_deep_customer_empathy_3',
                component: DeepCustomerEmpathy3,
                meta: {
                    authRequired: true,
                    showNavigation: true,
                    showNavigationInfo: true,
                    title: "Develop Customer Empathy",
                    pageNumber: "3 of 24"
                }
            },
            {
                path: '/be_deep_customer_empathy_4/:index',
                name: 'be_deep_customer_empathy_4',
                component: DeepCustomerEmpathy4,
                meta: {
                    authRequired: true,
                    showNavigation: true,
                    showNavigationInfo: true,
                    title: "Develop Customer Empathy",
                    pageNumber: "4 of 24"
                }
            },
            {
                path: '/be_deep_customer_empathy_5/:index',
                name: 'be_deep_customer_empathy_5',
                component: DeepCustomerEmpathy5,
                meta: {
                    authRequired: true,
                    showNavigation: true,
                    showNavigationInfo: true,
                    title: "Develop Customer Empathy",
                    pageNumber: "5 of 24"
                }
            },
            {
                path: '/be_deep_customer_empathy_6/:index',
                name: 'be_deep_customer_empathy_6',
                component: DeepCustomerEmpathy6,
                meta: {
                    authRequired: true,
                    showNavigation: true,
                    showNavigationInfo: true,
                    title: "Develop Customer Empathy",
                    pageNumber: "6 of 24"
                }
            },
            {
                path: '/be_deep_customer_empathy_7/:index',
                name: 'be_deep_customer_empathy_7',
                component: DeepCustomerEmpathy7,
                meta: {
                    authRequired: true,
                    showNavigation: true,
                    showNavigationInfo: true,
                    title: "Develop Customer Empathy",
                    pageNumber: "7 of 24"
                }
            },
            {
                path: '/be_deep_customer_empathy_8/:index',
                name: 'be_deep_customer_empathy_8',
                component: DeepCustomerEmpathy8,
                meta: {
                    authRequired: true,
                    showNavigation: true,
                    showNavigationInfo: true,
                    title: "Develop Customer Empathy",
                    pageNumber: "8 of 24"
                }
            },
            {
                path: '/be_deep_customer_empathy_9/:index',
                name: 'be_deep_customer_empathy_9',
                component: DeepCustomerEmpathy9,
                meta: {
                    authRequired: true,
                    showNavigation: true,
                    showNavigationInfo: true,
                    title: "Develop Customer Empathy",
                    pageNumber: "9 of 24"
                }
            },
            {
                path: '/be_go_broad_to_go_narrow_10/:index',
                name: 'be_go_broad_to_go_narrow_10',
                component: GoBroadToGoNarrow10,
                meta: {authRequired: true, showNavigation: false, showNavigationInfo: false, pageNumber: "10 of 24"}
            },
            {
                path: '/be_go_broad_to_go_narrow_11/:index',
                name: 'be_go_broad_to_go_narrow_11',
                component: GoBroadToGoNarrow11,
                meta: {
                    authRequired: true,
                    showNavigation: true,
                    showNavigationInfo: true,
                    title: "Go Broad To Go Narrow",
                    pageNumber: "11 of 24"
                }
            },
            {
                path: '/be_go_broad_to_go_narrow_12/:index',
                name: 'be_go_broad_to_go_narrow_12',
                component: GoBroadToGoNarrow12,
                meta: {
                    authRequired: true,
                    showNavigation: true,
                    showNavigationInfo: true,
                    title: "Go Broad To Go Narrow",
                    pageNumber: "12 of 24"
                }
            },
            {
                path: '/be_go_broad_to_go_narrow_13/:index',
                name: 'be_go_broad_to_go_narrow_13',
                component: GoBroadToGoNarrow13,
                meta: {
                    authRequired: true,
                    showNavigation: true,
                    showNavigationInfo: true,
                    title: "Go Broad To Go Narrow",
                    pageNumber: "13 of 24"
                },
            },
            {
                path: '/be_go_broad_to_go_narrow_14/:index',
                name: 'be_go_broad_to_go_narrow_14',
                component: GoBroadToGoNarrow14,
                meta: {
                    authRequired: true,
                    showNavigation: true,
                    showNavigationInfo: true,
                    title: "Go Broad To Go Narrow",
                    pageNumber: "14 of 24"
                }
            },
            {
                path: '/be_go_broad_to_go_narrow_15/:index',
                name: 'be_go_broad_to_go_narrow_15',
                component: GoBroadToGoNarrow15,
                meta: {
                    authRequired: true,
                    showNavigation: true,
                    showNavigationInfo: true,
                    title: "Go Broad To Go Narrow",
                    pageNumber: "15 of 24"
                }
            },
            {
                path: '/be_go_broad_to_go_narrow_16/:index',
                name: 'be_go_broad_to_go_narrow_16',
                component: GoBroadToGoNarrow16,
                meta: {
                    authRequired: true,
                    showNavigation: true,
                    showNavigationInfo: true,
                    title: "Go Broad To Go Narrow",
                    pageNumber: "16 of 24"
                }
            },
            {
                path: '/be_rapid_experiments_with_customers_17/:index',
                name: 'be_rapid_experiments_with_customers_17',
                component: RapidExperimentsWithCustomers17,
                meta: {authRequired: true, showNavigation: false, showNavigationInfo: false, pageNumber: "17 of 24"}
            },
            {
                path: '/be_rapid_experiments_with_customers_18/:index',
                name: 'be_rapid_experiments_with_customers_18',
                component: RapidExperimentsWithCustomers18,
                meta: {
                    authRequired: true,
                    showNavigation: true,
                    showNavigationInfo: true,
                    title: "Rapid experiments with customers",
                    pageNumber: "18 of 24"
                }
            },
            {
                path: '/be_rapid_experiments_with_customers_19/:index',
                name: 'be_rapid_experiments_with_customers_19',
                component: RapidExperimentsWithCustomers19,
                meta: {
                    authRequired: true,
                    showNavigation: true,
                    showNavigationInfo: true,
                    title: "Rapid experiments with customers",
                    pageNumber: "19 of 24"
                }
            },
            {
                path: '/be_rapid_experiments_with_customers_20/:index',
                name: 'be_rapid_experiments_with_customers_20',
                component: RapidExperimentsWithCustomers20,
                meta: {
                    authRequired: true,
                    showNavigation: true,
                    showNavigationInfo: true,
                    title: "Rapid experiments with customers",
                    pageNumber: "20 of 24"
                }
            },
            {
                path: '/be_rapid_experiments_with_customers_21/:index',
                name: 'be_rapid_experiments_with_customers_21',
                component: RapidExperimentsWithCustomers21,
                meta: {
                    authRequired: true,
                    showNavigation: true,
                    showNavigationInfo: true,
                    title: "Rapid experiments with customers",
                    pageNumber: "21 of 24"
                }
            },
            {
                path: '/be_rapid_experiments_with_customers_22/:index',
                name: 'be_rapid_experiments_with_customers_22',
                component: RapidExperimentsWithCustomers22,
                meta: {
                    authRequired: true,
                    showNavigation: true,
                    showNavigationInfo: true,
                    title: "Rapid experiments with customers",
                    pageNumber: "22 of 24"
                }
            },
            {
                path: '/be_rapid_experiments_with_customers_23/:index',
                name: 'be_rapid_experiments_with_customers_23',
                component: RapidExperimentsWithCustomers23,
                meta: {
                    authRequired: true,
                    showNavigation: true,
                    showNavigationInfo: true,
                    title: "Rapid experiments with customers",
                    pageNumber: "23 of 24"
                }
            },
            {
                path: '/finish_24/:index',
                name: 'finish_24',
                component: Finish24,
                meta: {authRequired: true, showNavigation: false, showNavigationInfo: false}
            },
            {
                path: '/finish_start_new_project_25/:index',
                name: 'finish_start_new_project_25',
                component: Finish24startNewProject,
                meta: {authRequired: true, showNavigation: false, showNavigationInfo: false}
            }

        ]
    }
]

export default routes
